import Enzymes, { getEnzymesWidth } from './Enzymes';
export { getEnzymesWidth };
export default Enzymes;
